import { useNetwork } from '@react-hooks-library/core';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

export const useIsOffline = () => {
  const { isOnline } = useNetwork();
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline && !wasOffline) {
      toast.error('Looks like you are offline', {
        icon: '⚠',
        duration: Infinity,
      });
    } else if (isOnline && wasOffline) {
      toast.dismiss();
      toast.success('You are back online!', {
        icon: '🟢',
      });
    }

    setWasOffline(!isOnline);
  }, [isOnline, wasOffline]);
};
